export const merchantInfoConstants = {
	RESET_UNDERWRITING_MERCHANT_INFO_STATE:
		"RESET_UNDERWRITING_MERCHANT_INFO_STATE",

	GET_UNDERWRITING_MERCHANT_INFO_SUCCESS:
		"GET_UNDERWRITING_MERCHANT_INFO_SUCCESS",
	GET_UNDERWRITING_MERCHANT_INFO_ERROR:
		"GET_UNDERWRITING_MERCHANT_INFO_ERROR",
	GET_UNDERWRITING_MERCHANT_INFO_REQUEST:
		"GET_UNDERWRITING_MERCHANT_INFO_REQUEST",

	SAVE_UNDERWRITING_MERCHANT_INFO_SUCCESS:
		"SAVE_UNDERWRITING_MERCHANT_INFO_SUCCESS",
	SAVE_UNDERWRITING_MERCHANT_INFO_ERROR:
		"SAVE_UNDERWRITING_MERCHANT_INFO_ERROR",

	SET_MERCHANT_INFO_HIGH_RISK: "SET_MERCHANT_INFO_HIGH_RISK",
};
